import React from "react";
import "./Signup.css";
import { InfoModal } from "./InfoModal.js";
import { CheckSignupModal } from "./CheckSignupModal.js";
import { GDPRModal } from "./GDPRModal.js";
import { ReadOnlySeatmap } from "./ReadOnlySeatmap.js";
import PageVisibility from "react-page-visibility";

//This component will contain the signup information page that is shown first when the user clicks signup in the nav
//Will inherrit it's Post props from Signup.js
//Onchange will trigger back to Signup.js
//Info should be changable through modal

//Should show price
//Number of available seats

export class SignupInfo extends React.Component {
  constructor() {
    super();
    this.startSignup = this.startSignup.bind(this);
    this.showInfoModal = this.showInfoModal.bind(this);
    this.closeInfoModal = this.closeInfoModal.bind(this);
    this.showGDPRModal = this.showGDPRModal.bind(this);
    this.closeGDPRModal = this.closeGDPRModal.bind(this);
    this.closeCheckSignupModal = this.closeCheckSignupModal.bind(this);
    this.seatsFull = this.seatsFull.bind(this);
    this.showCheckSignupModal = this.showCheckSignupModal.bind(this);

    this.state = {
      promptInfoModal: false,
      infoModalConfirmed: false,
      promptGDPRModal: false,
      promptCheckSignupModal: false,
      visibility: true,
      signupFull: false
    };
  }

  handleVisibilityChange = isVisible => {
    this.setState({ visibility: isVisible });
  };

  showInfoModal(e) {
    //We show a modal that explains how the signup process will work with payment

    this.setState({ promptInfoModal: true });
    //this.props.setStartSignup(e.target.value);
  }

  showGDPRModal(e) {
    //We show a modal that explains what we store about the user

    this.setState({ promptGDPRModal: true });
  }

  showCheckSignupModal(e) {
    this.setState({ promptCheckSignupModal: true });
  }

  startSignup(e) {
    this.props.setStartSignup(e.target.value);
  }

  seatsFull() {
    this.setState({ signupFull: true });
  }

  closeInfoModal() {
    this.setState({ promptInfoModal: false });
  }
  closeGDPRModal() {
    this.setState({ promptGDPRModal: false });
  }

  closeCheckSignupModal() {
    this.setState({ promptCheckSignupModal: false });
  }

  render() {
    return (
      <div className="Signup">
        <div
          className="Post"
          dangerouslySetInnerHTML={{ __html: this.props.post }}
        />

        <br />
        <div>
          {this.props.signupOpen === true &&
            this.props.signupOver === false &&
            this.state.signupFull === false && (
              <button
                className="btn btno btn-success help bigBtn"
                value="true"
                onClick={this.showInfoModal}
              >
                Start påmelding
              </button>
            )}
          {this.props.signupOpen === true &&
            this.props.signupOver === false &&
            this.state.signupFull === true && (
              <button
                className="btn disabled  btn-warning bigBtn"
                disabled={true}
                value="true"
              >
                Alle plasser er opptatte
              </button>
            )}
        </div>
        <div>
          {this.props.signupOpen === true && (
            <button
              className="btn btno btn-info help"
              onClick={this.showCheckSignupModal}
            >
              Sjekk min påmeldingsstatus
            </button>
          )}
        </div>

        {this.state.promptInfoModal === true &&
          this.props.signupOpen === true &&
          this.props.signupOver === false && (
            <InfoModal
              startSignup={this.startSignup}
              closeInfoModal={this.closeInfoModal}
            />
          )}
        {this.state.promptCheckSignupModal === true &&
          this.props.signupOpen === true && (
            <CheckSignupModal
              closeCheckSignupModal={this.closeCheckSignupModal}
              foodTicketEnabled={this.props.foodTicket}
            />
          )}
        {this.state.promptGDPRModal === true &&
          this.props.signupOpen === true && (
            <GDPRModal closeGDPRModal={this.closeGDPRModal} />
          )}

        {this.props.signupOpen === true && this.props.showSeatMap === true && (
          <PageVisibility onChange={this.handleVisibilityChange}>
            <ReadOnlySeatmap
              signupOver={this.props.signupOver}
              visibility={this.state.visibility}
              seatsFull={this.seatsFull}
              onSeatmapClick={this.showInfoModal}
              signupFull={this.state.signupFull}
            />
          </PageVisibility>
        )}

        {this.props.signupOpen === true && (
          <button
            className="btn btno btn-info help"
            value="true"
            onClick={this.showGDPRModal}
          >
            Hva lagrer vi om deg?
          </button>
        )}
      </div>
    );
  }
}

export default SignupInfo;



// WEBPACK FOOTER //
// ./src/Components/Signup/SignupInfo.js